module.exports = __webpack_public_path__ + "static/img/complianceSystem4.f6e30ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/complianceSystem4.jpg
// module id = K7pX
// module chunks = 1